import { cn } from "@repo/ui/lib/utils";

interface TitleProps {
  children: React.ReactNode;
  className?: string;
}

export function Title({ children, className }: TitleProps) {
  return (
    <div className={cn("text-3xl font-bold text-primary", className ?? "")}>
      {children}
    </div>
  );
}
